import { apps, permissions } from './rolesAndPermission';
import { PermissionArrayType } from './rolesAndPermissions31Dec24';
import { userPermissionContent } from './userPermissionContent';

const taskManagerPermissionsForManager: PermissionArrayType = [
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 86,
    key: userPermissionContent.feature.can_be_assigned_a_task_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

const availabilityPermissionsForManager: PermissionArrayType = [
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

const ordersAndPaymentPermissionsForManager: PermissionArrayType = [
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 8,
    featureId: 26,
    key: userPermissionContent.feature.refund_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

const timeCardsPermissionsForManager: PermissionArrayType = [
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const userPermissionsForMom7Jan2025 = [
  ...taskManagerPermissionsForManager,
  ...availabilityPermissionsForManager,
  ...ordersAndPaymentPermissionsForManager,
  ...timeCardsPermissionsForManager,
];
